/**
 * BuzzLogo — the "Hive Signal" bumblebee mark.
 * Round friendly honey body + coral buzz-lines + sleek antennae.
 * Renders as inline SVG so it stays crisp at any size.
 *
 * Usage:
 *   <BuzzLogo size={18} />
 *   <BuzzLogo size={40} accent="#F7F6F2" />  // white body for dark tiles
 */
export default function BuzzLogo({ size = 24, accent }) {
  const bodyFill = accent || "#F5C543"; // honey by default
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      <defs>
        <clipPath id={`buzz-body-${size}`}>
          <ellipse cx="52" cy="56" rx="24" ry="26" />
        </clipPath>
      </defs>
      {/* Buzz lines */}
      <line x1="8"  y1="46" x2="20" y2="46" stroke="#D96C5B" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="10" y1="56" x2="18" y2="56" stroke="#D96C5B" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="8"  y1="66" x2="20" y2="66" stroke="#D96C5B" strokeWidth="2.5" strokeLinecap="round" />
      {/* Wings */}
      <ellipse cx="38" cy="32" rx="12" ry="7" fill="#F7F6F2" opacity="0.75" />
      <ellipse cx="66" cy="32" rx="12" ry="7" fill="#F7F6F2" opacity="0.75" />
      {/* Body */}
      <ellipse cx="52" cy="56" rx="24" ry="26" fill={bodyFill} />
      {/* Stripes */}
      <g clipPath={`url(#buzz-body-${size})`}>
        <rect x="20" y="48" width="60" height="5" fill="#1E3A2F" />
        <rect x="20" y="64" width="60" height="5" fill="#1E3A2F" />
      </g>
      {/* Coral stinger */}
      <circle cx="74" cy="70" r="3.5" fill="#D96C5B" />
      {/* Antennae */}
      <path d="M45 32 Q41 22 47 16" stroke="#1E3A2F" strokeWidth="2.2" strokeLinecap="round" fill="none" />
      <path d="M59 32 Q63 22 57 16" stroke="#1E3A2F" strokeWidth="2.2" strokeLinecap="round" fill="none" />
      {/* Eyes */}
      <circle cx="45" cy="44" r="2.2" fill="#1E3A2F" />
      <circle cx="59" cy="44" r="2.2" fill="#1E3A2F" />
    </svg>
  );
}
